import React, { createContext, ReactNode, useContext } from 'react';
import type { DeepLinkData } from 'branch-sdk';

type HandleLegacyBranchInitFn = (event: {
  detail: { err: Error | null; data: object | null };
}) => void;
type SetIdentityFn = (externalIdentityHash?: string) => void;
type CreateLinkFn = (linkData: {
  feature?: string;
  data?: DeepLinkData['data'];
  isLoggedIn?: boolean;
}) => void;

export interface BranchContextValue {
  isProcessing: boolean;
  hasApp: boolean;
  handleLegacyBranchInit: HandleLegacyBranchInitFn;
  setIdentity: SetIdentityFn;
  identityHash: string | null;
  createLink: CreateLinkFn;
  error: string | Error | null;
  appLink: string | null;
  isReady?: boolean;
}

export const BranchContext = createContext<BranchContextValue | null>(null);

if (process.env.NODE_ENV === 'development') {
  BranchContext.displayName = 'BranchContext';
}

export function useStravaBranch() {
  const context = useContext(BranchContext);

  if (!context) {
    throw new Error('useStravaBranch must be used within the BranchProvider');
  }

  return context;
}

interface BranchProviderProps extends BranchContextValue {
  children: ReactNode;
}

export const BranchProvider = ({
  children,
  ...branchContextValue
}: BranchProviderProps) => {
  return (
    <BranchContext.Provider
      value={{
        ...branchContextValue
      }}
    >
      {children}
    </BranchContext.Provider>
  );
};

if (process.env.NODE_ENV === 'development') {
  BranchProvider.displayName = 'BranchProvider';
}
